import { AccountsAPI, CustomerAPI } from 'api'

export const getImports = async data => (
  AccountsAPI.get('/syncAudit/summaries', {params: data})
)

export const uploadCsv = async (data, onUploadProgress) => (
	AccountsAPI.post(`/csv`, data, {
		headers: {'Content-type': 'multipart/form-data'},
		onUploadProgress: onUploadProgress
	})
)

export const startImport = async (data) => (
  AccountsAPI.post(`/csv/import`, data)
)

export const generateImportErrorCSV = async id => (
  AccountsAPI.get(`/syncAudit/jobDetails/${id}`)
)

export const suggestImportSource = ({ suggestion }) => (
  CustomerAPI.post(`/integrationsuggestions/imports?suggestion=${suggestion}`)
)
